<div *ngIf="visible" class="pay-banner">
  <lucide-icon [name]="icon" [size]="16" class="pay-banner__icon"></lucide-icon>

  <div class="pay-banner__content">
    <span class="pay-banner__title">{{ title }}</span>
    <span *ngIf="body" class="pay-banner__body">{{ body }}</span>
  </div>

  <button
    *ngIf="dismissible"
    type="button"
    class="pay-banner__dismiss"
    (click)="dismiss()"
    aria-label="Dismiss">
    <lucide-icon name="x" [size]="14"></lucide-icon>
  </button>
</div>
